import {Component, OnInit, Optional} from '@angular/core';
import {ITableHeader} from '../../../interfaces/table-header';
import {TableHeaderService} from '../../services/table-header.service';
import {LoaderService} from '../../services/loader.service';
import {UserService} from '../../services/user.service';
import {TableEntityExtension} from "../../extensions/table-entity-extension/table-entity.extension";
import {TableEntityExtensionService} from "../../extensions/table-entity-extension/table-entity-extension.service";
import {ActivatedRoute} from "@angular/router";
import {CardService} from "../../components/card/card.service";
import * as moment from 'moment';
import FileSaver from 'file-saver';

@Component({
  selector: 'table-user',
  templateUrl: './table-user.component.html',
  providers: [LoaderService]
})
export class TableUserComponent extends TableEntityExtension implements OnInit {

  headers: ITableHeader[] = [
    this.tableHeaderService.id(),
    this.tableHeaderService.account({filter: false}),
    this.tableHeaderService.store(),
    this.tableHeaderService.device({sort: false}),
    this.tableHeaderService.info({sort: false, filter: false}),
    // this.tableHeaderService.coins(),
    // this.tableHeaderService.authAt({filter: false}),
    this.tableHeaderService.createdAt(),
    // this.tableHeaderService.actions(),
  ];

  query: any = {
    filters: {},
   order: null,
    relations: ['store', 'account', 'devices']
  };

  constructor(public loaderService: LoaderService,
              protected route: ActivatedRoute,
              protected modelService: UserService,
              protected tableEntityExtensionService: TableEntityExtensionService,
              @Optional() protected cardService: CardService,
              private tableHeaderService: TableHeaderService,) {
    super(
      modelService,
      cardService,
      loaderService,
      tableEntityExtensionService,
      route
    );
  }

  ngOnInit(): void {
    this.routesInit('users');
  }
  exportUsers() {
    this.modelService.exportCSV({storeId: this.query.filters.store}).subscribe((data) => {
      const blob = new Blob([data], { type: 'application/octet-stream' });
      const fileName = `users${moment().format('YY-MM-DD-HH-mm-ss')}.csv`;
      FileSaver.saveAs(blob, fileName);
    })
  }
}
